import React, { useState } from "react";
import "../styles/Programs.scss";
import { motion } from "framer-motion";

import BlocksOne from "../assets/images/blocksOne.jpg";
import BlocksTwo from "../assets/images/blocksTwo.jpg";
import HtmlCss from "../assets/images/htmlcss.jpg";
import JavaScriptGaming from "../assets/images/javascriptgaming.jpg";
import JavaScript from "../assets/images/javascript.jpg";
import WordPress from "../assets/images/wordpress.jpg";
import ReactJs from "../assets/images/react.jpg";
import Python from "../assets/images/python.jpg";
import NodeJs from "../assets/images/nodejs.jpg";
import Php from "../assets/images/php.jpg";
import Freelancing from "../assets/images/freelancing.jpg";
import Social from "../assets/images/social.jpg";

const programsData = [
  {
    title: "Programming with Blocks (7+)",
    description:
      "A fun introduction to programming concepts using visual blocks for young learners.",
    image: BlocksOne,
    duration: "3 months",
    level: "Beginner (Ages 7-11)",
    details: {
      curriculum: [
        "Basic programming concepts through visual blocks",
        "Problem-solving skills development",
        "Simple game creation",
        "Interactive storytelling",
        "Basic animation principles",
      ],
      skills: [
        "Logical thinking",
        "Problem solving",
        "Creativity",
        "Basic coding concepts",
      ],
      projects: ["Simple games", "Interactive stories", "Basic animations"],
      schedule: "2 sessions per week, 1.5 hours each",
    },
  },
  {
    title: "Programming with Blocks (12+)",
    description:
      "Advanced block-based programming for teenagers, bridging the gap to text-based coding.",
    image: BlocksTwo,
    duration: "4 months",
    level: "Intermediate (Ages 12+)",
    details: {
      curriculum: [
        "Advanced block programming concepts",
        "Introduction to algorithms",
        "Game mechanics and physics",
        "Complex project development",
        "Transition to text-based coding",
      ],
      skills: [
        "Algorithm design",
        "Project planning",
        "Advanced logic",
        "Basic physics concepts",
      ],
      projects: [
        "Complex games",
        "Physics simulations",
        "Interactive applications",
      ],
      schedule: "2 sessions per week, 2 hours each",
    },
  },
  {
    title: "HTML & CSS",
    description:
      "Learn to create beautiful and responsive websites from scratch.",
    image: HtmlCss,
    duration: "3 months",
    level: "Beginner",
    details: {
      curriculum: [
        "HTML5 fundamentals",
        "CSS3 styling and animations",
        "Responsive design principles",
        "Flexbox and Grid layouts",
        "CSS frameworks introduction",
      ],
      skills: [
        "Web structure",
        "Styling",
        "Responsive design",
        "Modern CSS features",
      ],
      projects: ["Personal portfolio", "Responsive layouts", "Landing pages"],
      schedule: "3 sessions per week, 2 hours each",
    },
  },
  {
    title: "JavaScript Gaming",
    description:
      "Create interactive games while learning JavaScript fundamentals.",
    image: JavaScriptGaming,
    duration: "4 months",
    level: "Intermediate",
    details: {
      curriculum: [
        "JavaScript basics",
        "Game development concepts",
        "Canvas API",
        "Sprite animation",
        "Game physics",
      ],
      skills: [
        "JavaScript programming",
        "Game logic",
        "Animation",
        "User interaction",
      ],
      projects: [
        "Browser-based games",
        "Interactive animations",
        "Simple physics games",
      ],
      schedule: "3 sessions per week, 2 hours each",
    },
  },
  {
    title: "JavaScript Advanced",
    description:
      "Master advanced JavaScript concepts and modern development practices.",
    image: JavaScript,
    duration: "4 months",
    level: "Advanced",
    details: {
      curriculum: [
        "ES6+ features",
        "Asynchronous programming",
        "Design patterns",
        "Testing and debugging",
        "Performance optimization",
      ],
      skills: [
        "Advanced JS concepts",
        "Modern JS practices",
        "Problem-solving",
        "Code optimization",
      ],
      projects: [
        "Complex web applications",
        "Real-time features",
        "API integrations",
      ],
      schedule: "3 sessions per week, 2 hours each",
    },
  },
  {
    title: "WordPress",
    description:
      "Build professional websites using WordPress and custom development.",
    image: WordPress,
    duration: "3 months",
    level: "Beginner to Intermediate",
    details: {
      curriculum: [
        "WordPress basics",
        "Theme customization",
        "Plugin development",
        "Custom post types",
        "E-commerce integration",
      ],
      skills: [
        "WordPress development",
        "PHP basics",
        "Theme customization",
        "Website management",
      ],
      projects: ["Business websites", "E-commerce stores", "Custom themes"],
      schedule: "2 sessions per week, 2 hours each",
    },
  },
  {
    title: "React",
    description: "Create modern web applications with React and its ecosystem.",
    image: ReactJs,
    duration: "4 months",
    level: "Intermediate to Advanced",
    details: {
      curriculum: [
        "React fundamentals",
        "State management",
        "Hooks and custom hooks",
        "React Router",
        "Testing and deployment",
      ],
      skills: [
        "Component development",
        "State management",
        "Modern React practices",
        "Testing",
      ],
      projects: [
        "Single-page applications",
        "Full-stack React apps",
        "Progressive web apps",
      ],
      schedule: "3 sessions per week, 2 hours each",
    },
  },
  {
    title: "Python",
    description:
      "Learn Python programming for various applications and data science.",
    image: Python,
    duration: "4 months",
    level: "Beginner to Intermediate",
    details: {
      curriculum: [
        "Python basics",
        "Object-oriented programming",
        "Data structures",
        "File handling",
        "Basic data science",
      ],
      skills: [
        "Python programming",
        "Problem-solving",
        "Data handling",
        "Algorithm design",
      ],
      projects: ["Console applications", "Data analysis", "Automation scripts"],
      schedule: "3 sessions per week, 2 hours each",
    },
  },
  {
    title: "Node.js",
    description:
      "Build scalable backend applications with Node.js and Express.",
    image: NodeJs,
    duration: "4 months",
    level: "Intermediate",
    details: {
      curriculum: [
        "Node.js fundamentals",
        "Express framework",
        "RESTful APIs",
        "Database integration",
        "Authentication & security",
      ],
      skills: [
        "Backend development",
        "API design",
        "Database management",
        "Server deployment",
      ],
      projects: ["REST APIs", "Real-time applications", "Full-stack projects"],
      schedule: "3 sessions per week, 2 hours each",
    },
  },
  {
    title: "PHP & MySQL",
    description:
      "Develop dynamic web applications with PHP and MySQL databases.",
    image: Php,
    duration: "4 months",
    level: "Intermediate",
    details: {
      curriculum: [
        "PHP basics",
        "MySQL database design",
        "CRUD operations",
        "Authentication systems",
        "MVC architecture",
      ],
      skills: [
        "PHP programming",
        "Database design",
        "Backend logic",
        "Security practices",
      ],
      projects: [
        "Dynamic websites",
        "Content management systems",
        "E-commerce features",
      ],
      schedule: "3 sessions per week, 2 hours each",
    },
  },
  {
    title: "Freelancing",
    description:
      "Learn how to build a successful freelancing career by mastering client communication, project management, and portfolio development.",
    image: Freelancing,
    duration: "2 months",
    level: "Beginner to Intermediate",
    details: {
      curriculum: [
        "Introduction to freelancing platforms",
        "Creating a strong profile and portfolio",
        "Writing winning proposals",
        "Time and project management",
        "Client communication and negotiation",
      ],
      skills: [
        "Proposal writing",
        "Client management",
        "Portfolio building",
        "Time tracking",
        "Self-marketing",
      ],
      projects: [
        "Personal freelancing portfolio website",
        "Simulated client project workflows",
        "Live project bids and proposals",
      ],
      schedule: "2 sessions per week, 1.5 hours each",
    },
  },
  {
    title: "Social Media",
    description:
      "Master social media marketing by learning content strategy, platform algorithms, and audience engagement techniques.",
    image: Social,
    duration: "3 months",
    level: "Beginner",
    details: {
      curriculum: [
        "Social media platform overviews (Facebook, Instagram, LinkedIn, TikTok)",
        "Content planning and calendar creation",
        "Hashtag and trend research",
        "Engagement strategies",
        "Analytics and performance tracking",
      ],
      skills: [
        "Content creation",
        "Audience engagement",
        "Brand development",
        "Social media analytics",
        "Campaign planning",
      ],
      projects: [
        "Social media strategy for a fictional brand",
        "Content calendar for 1 month",
        "Growth and engagement report based on analytics",
      ],
      schedule: "3 sessions per week, 1 hour each",
    },
  },
];

export default function Programs() {
  const [selectedProgram, setSelectedProgram] = useState(null);

  const handleProgramClick = (program) => {
    setSelectedProgram(program);
  };

  const handleCloseModal = () => {
    setSelectedProgram(null);
  };

  return (
    <section className="programs">
      <div className="container">
        <div className="programs__grid">
          {programsData.map((program, index) => (
            <motion.div
              key={index}
              className="program-card"
              onClick={() => handleProgramClick(program)}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, ease: "easeOut" }}
              viewport={{ once: true, amount: 0.2 }}
            >
              <img
                style={{ marginBottom: "10px", objectFit: "cover" }}
                src={program.image}
                width="100%"
                height="200px"
                alt={program.title}
              />
              <h3 className="program-card__title">{program.title}</h3>
              <p className="program-card__description">{program.description}</p>
              <div className="program-card__details">
                <span className="program-card__duration">
                  {program.duration}
                </span>
                <span className="program-card__level">{program.level}</span>
              </div>
            </motion.div>
          ))}
        </div>

        {selectedProgram && (
          <div className="program-modal" onClick={handleCloseModal}>
            <div
              className="program-modal__content"
              onClick={(e) => e.stopPropagation()}
            >
              <button
                className="program-modal__close"
                onClick={handleCloseModal}
              >
                ×
              </button>
              <div className="program-modal__header">
                <h2 className="program-modal__title">
                  {selectedProgram.title}
                </h2>
              </div>
              <div className="program-modal__body">
                <div className="program-modal__section">
                  <h3>About the Program</h3>
                  <p>{selectedProgram.description}</p>
                  <div className="program-modal__info">
                    <span>Duration: {selectedProgram.duration}</span>
                    <span>Level: {selectedProgram.level}</span>
                  </div>
                </div>
                <div className="program-modal__section">
                  <h3>Curriculum</h3>
                  <ul>
                    {selectedProgram.details.curriculum.map((item, index) => (
                      <li key={index}>{item}</li>
                    ))}
                  </ul>
                </div>
                <div className="program-modal__section">
                  <h3>Skills You'll Gain</h3>
                  <div className="program-modal__skills">
                    {selectedProgram.details.skills.map((skill, index) => (
                      <span key={index} className="skill-tag">
                        {skill}
                      </span>
                    ))}
                  </div>
                </div>
                <div className="program-modal__section">
                  <h3>Projects</h3>
                  <ul>
                    {selectedProgram.details.projects.map((project, index) => (
                      <li key={index}>{project}</li>
                    ))}
                  </ul>
                </div>
                <div className="program-modal__section">
                  <h3>Schedule</h3>
                  <p>{selectedProgram.details.schedule}</p>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </section>
  );
}
